export default "__VITE_ASSET__216d4b45__"